
import { Component, Prop, Vue } from 'vue-property-decorator';
import ProductCard from '@/components/products/ProductCard.vue';

@Component({
  components: { ProductCard },
})
export default class PagesBlock extends Vue {
  @Prop(Array)
  pages!: any;
}
